import { render } from "./BiogasOverview.vue?vue&type=template&id=73de839f&scoped=true"
import script from "./BiogasOverview.vue?vue&type=script&lang=js"
export * from "./BiogasOverview.vue?vue&type=script&lang=js"

import "./BiogasOverview.vue?vue&type=style&index=0&id=73de839f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73de839f"]])

export default __exports__